import React from "react";
import styled from "styled-components";

const StyledFlex = styled.div`
  display: flex;
  justify-content: ${({ justify }) => (justify ? justify : "initial")};
  flex-direction: ${({ direction }) => (direction ? direction : "initial")};
  flex-wrap: ${({ wrap }) => (wrap ? wrap : "initial")};
`;

export default function Flex({
  className,
  children,
  justify,
  direction,
  wrap,
  dataAt
}) {
  return (
    <StyledFlex
      className={className}
      justify={justify}
      direction={direction}
      wrap={wrap}
      data-at={dataAt}
    >
      {children}
    </StyledFlex>
  );
}

Flex.defaultProps = { dataAt: null };